module.exports = __webpack_public_path__ + "static/media/Bridge_Home_Loan_Program.b071bfe3.png";